export default __webpack_public_path__ + "static/media/signUpImg.1096f29b.svg";